export function shouldEnterIdleMotion(
  currentAnimation: string | null,
  isUserSpeaking: boolean,
): boolean {
  return currentAnimation === 'listening' && !isUserSpeaking
}

interface IdleMotionSchedulerOptions<TTimer> {
  delayMs: number
  getCurrentAnimation: () => string | null
  isUserSpeaking: () => boolean
  enterIdleMotion: () => void
  scheduleTimer: (callback: () => void, delayMs: number) => TTimer
  cancelTimer: (timer: TTimer) => void
}

export function createIdleMotionScheduler<TTimer>({
  delayMs,
  getCurrentAnimation,
  isUserSpeaking,
  enterIdleMotion,
  scheduleTimer,
  cancelTimer,
}: IdleMotionSchedulerOptions<TTimer>) {
  let timer: TTimer | null = null

  const cancel = () => {
    if (timer === null) return
    cancelTimer(timer)
    timer = null
  }

  const schedule = () => {
    cancel()
    if (getCurrentAnimation() !== 'listening') return

    timer = scheduleTimer(() => {
      timer = null
      if (shouldEnterIdleMotion(getCurrentAnimation(), isUserSpeaking())) {
        enterIdleMotion()
      }
    }, delayMs)
  }

  return { schedule, cancel }
}
